import { render, staticRenderFns } from "./PayPeriodSettingsCard.vue?vue&type=template&id=f940a630&scoped=true"
import script from "./PayPeriodSettingsCard.vue?vue&type=script&lang=js"
export * from "./PayPeriodSettingsCard.vue?vue&type=script&lang=js"
import style0 from "./PayPeriodSettingsCard.vue?vue&type=style&index=0&id=f940a630&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f940a630",
  null
  
)

export default component.exports